import projection from '../generated/pwj207f1.json'; import { AcceptanceManifest } from '../types';
export const pwj207f1AcceptanceManifest = projection as AcceptanceManifest;
